import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { CheckCircle, Eye, EyeSlash, XCircle } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Validation from "../../hooks/Validation";
import { resetPassword } from "../../store/actions/adminAction";
import { userReset } from "../../store/reducerSlice/user";
import Loader from "../common/loader/Loader";
import ApiResponsePopup from "../common/modal/ApiResponsePopup";
import Styles from "../Login/LoginForm.module.css";

const formElements = [
  {
    key: "newPassword",
    label: "Password",
    placeHolder: "Enter password",
    type: "password",
  },
  {
    key: "confirmPassword",
    label: "Confirm Password",
    placeHolder: "Enter confirm password",
    type: "password",
  },
];

// A custom hook that builds on useLocation to parse
// the query string for you.

const ChangePasswordForm = () => {
  const { token } = useParams();
  const [passwordDetail, setPasswordDetail] = useState({
    newPassword: null,
    confirmPassword: null,
  });
  const [eyes, setEyes] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [activationKeyNotExist, setActivationKeyNotExist] = useState(null);
  const navigate = useNavigate();
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation(passwordDetail);
  const dispatch = useDispatch();
  const {
    isLoader,
    isRecordAdded,
    error: apiError,
  } = useSelector((state) => state.admin);
  const [successMessage, setSuccessMessage] = useState(null);

  const submitHandler = (e) => {
    console.log("actioncalled");
    e.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    console.log("actioncalled 57", isActionCalled);
    if (!isError() && error !== null && isActionCalled) {
      console.log("actioncalled 57", isActionCalled);
      const { newPassword, ...rest } = passwordDetail;
      dispatch(
        resetPassword({
          ...rest,
          password: newPassword,
          token,
        })
      ).then((payload) => {
        if (payload?.payload?.success) {
          setSuccessMessage(payload?.payload?.message);
          setTimeout(() => {
            hideHandlerRes();
          }, 3000);
        }
      });
      setIsActionCalled(false);
    } else {
      console.log("actioncalled 76 else", isActionCalled);
      setSuccessMessage(null);
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const hideHandlerRes = () => {
    dispatch(userReset());
    navigate("/");
  };

  useEffect(() => {
    return () => {
      dispatch(userReset());
      dispatch(
        resetPassword({
          token,
        })
      ).then(({ payload }) => {
        if (!payload?.success) {
          setActivationKeyNotExist(payload?.message);
          setTimeout(() => {
            hideHandlerRes();
          }, 3000);
        }
      });
    };
  }, []);

  return (
    <Form
      onSubmit={(e) => submitHandler(e)}
      style={{ maxWidth: 600, margin: "0 auto" }}
      noValidate
    >
      <h1 className={Styles.h1}>Change Password</h1>
      {isLoader && <Loader />}
      {apiError && (
        <Alert variant={"danger"}>
          {apiError?.message || "Access denied! Please try again"}
        </Alert>
      )}
      {successMessage && <Alert variant={"success"}>{successMessage}</Alert>}
      {activationKeyNotExist ? (
        ""
      ) : (
        <>
          {formElements.map((element, i) => {
            return (
              <Form.Group
                className="mb-4 rowField"
                controlId="formBasicEmail"
                key={i}
              >
                <Form.Label>
                  {element.label} <span className="required">*</span>
                </Form.Label>
                <Form.Control
                  type={eyes[element.key] ? "text" : element.type}
                  name={element.key}
                  placeholder={element.placeHolder}
                  value={passwordDetail && passwordDetail[element.key]}
                  onChange={(e) => {
                    setPasswordDetail({
                      ...passwordDetail,
                      [element.key]: e.target.value,
                    });
                    // resetValidator(e.target.name);
                    //element.key === 'newPassword' &&
                    // checkValidator(element.key)
                  }}
                  onKeyUp={(e) => {
                    if (
                      element.key === "newPassword" &&
                      passwordDetail?.confirmPassword != null
                    ) {
                      checkValidator();
                    } else {
                      checkValidator(element.key);
                    }
                  }}
                  isInvalid={
                    error &&
                    error !== null &&
                    typeof error[element.key] !== "object" &&
                    error[element.key]
                  }
                />
                {element.key !== "email" ? (
                  <div
                    className="eyeIcon"
                    onClick={(e) =>
                      setEyes({
                        ...eyes,
                        [element.key]: !eyes[element.key],
                      })
                    }
                  >
                    {eyes[element.key] ? <Eye /> : <EyeSlash />}
                  </div>
                ) : null}
                <Form.Control.Feedback type="invalid">
                  {error &&
                    error !== null &&
                    typeof error[element.key] !== "object" &&
                    error[element.key]}
                </Form.Control.Feedback>
                {element.key === "newPassword" && (
                  <Form.Text
                    className={`passwordRules ${
                      error && passwordDetail[element.key] && "valid"
                    }`}
                  >
                    <h3>Your password must have:</h3>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.lowercase &&
                            error[element.key]?.lowercase
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.lowercase ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one lowercase letter
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.uppercase &&
                            error[element.key]?.uppercase
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.uppercase ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one UPPERCASE letter
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.number &&
                            error[element.key]?.number
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.number ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one number
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.special &&
                            error[element.key]?.special
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.special ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least one special character
                    </p>
                    <p
                      className={
                        passwordDetail[element.key]
                          ? error &&
                            error?.newPassword?.length &&
                            error[element.key]?.length
                            ? "invalid"
                            : ""
                          : ""
                      }
                    >
                      {!passwordDetail?.newPassword ? (
                        <XCircle />
                      ) : error?.newPassword?.length ? (
                        <XCircle />
                      ) : (
                        <CheckCircle />
                      )}{" "}
                      At least 8 characters
                    </p>
                  </Form.Text>
                )}
              </Form.Group>
            );
          })}

          <div className="requiredNote">
            Note: You must complete all the mandatory fields.
          </div>
          <br />
          <Button
            className="btn-primary mt-2 border-0 mb-4"
            style={{
              fontSize: "14px",
              height: "48px",
              filter: "drop-shadow()",
              boxShadow: "1px 4px 8px 1px rgba(133, 93, 217, 0.5)",
            }}
            type="submit"
          >
            Update
          </Button>
        </>
      )}
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordAdded,
          successMsg: "Password successfully added!",
          updateMsg: "Password successfully updated!",
        }}
      />
    </Form>
  );
};

export default ChangePasswordForm;
